// The comparison viewer (/compare, the Compare button and the Dev | Prd | Dev vs Prd switch); false hides it
export const COMPARISON_VIEWER = true;
